var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.415218580951887,18.8801774860666 L27.079372579643405,12.9947367334874 h-1.2463106656066931 l-4.9688438378793185,5.162877725899864 l-3.9685155404844696,-5.162877725899864 h-4.558873224192905 l5.979011430002635,7.810276699169075 l-5.96917213527416,6.2002503700121485 h1.2495904305161845 l5.273861974462008,-5.480685530165477 l4.194819319239369,5.480685530165477 h4.598230403106799 L21.415218580951887,18.8801774860666 zM14.134140481881218,13.897190970128463 h2.1088888368029037 l9.570354005895608,12.253589585222263 l-2.1088888368029037,-0.011992747330777952 L14.134140481881218,13.897190970128463 z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.2ed91b1ce8370418f258919662778e54.svg";